module.exports = __webpack_public_path__ + "static/media/ImporterHero.f00fac8d.svg";